module.exports = __webpack_public_path__ + "static/media/recipe_top_banner_ja.ef6a00f4.png";